<a class="more-appointments-link" data-appointment-booking-provider-widget-behaviour="open-appointment-modal">
  See full schedule
</a>
